import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface SectionTracking {
  section: string
  subSection: string
  pageName: string
}

interface SectionState {
  value: SectionTracking
}

const initialState: SectionState = { value: { section: '', subSection: '', pageName: '' } }

const sectionSlice = createSlice({
  name: 'section',
  initialState,
  reducers: {
    updateSection(
      state,
      action: PayloadAction<{
        section: string
        subSection: string
        pageName: string
      }>
    ) {
      state.value = {
        ...state.value,
        ...action.payload,
      }
    },
  },
})

export const { updateSection } = sectionSlice.actions
export default sectionSlice.reducer
